import { TYPE_AVERAGE, TYPE_SUM } from "@/helpers/constants";
import { configNumberFormatter, formatters } from "@/helpers/formatters";
import { trendColors } from "@/settings/summary/summary";
import { InputDictionary } from "@/types/common";

export default <InputDictionary[]>[
  {
    title: "Acquisitions",
    value: "acquisitions",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "App Events",
    value: "app_events",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "App Installs",
    value: "app_installs",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Bookings",
    value: "bookings",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Budget",
    value: "channel_budget",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    isCountableMetric: true,
    calculationType: TYPE_SUM,
  },
  {
    title: "Clicks",
    value: "clicks",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Completed Views",
    value: "completed_views",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "CPA",
    value: "cpa",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPAE",
    value: "cpae",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPB",
    value: "cpb",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    type: TYPE_AVERAGE,
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPC",
    value: "cpc",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPCV",
    value: "cpcv",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPE",
    value: "cpe",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPER",
    value: "cper",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPI",
    value: "cpi",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPL",
    value: "cpl",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPIA",
    value: "cpia",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPLA",
    value: "cpla",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPLC",
    value: "cplc",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPLV",
    value: "cplv",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPM",
    value: "cpm",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPP",
    value: "cpp",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPPL",
    value: "cppl",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPS",
    value: "cps",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPSA",
    value: "cpsa",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CPSV",
    value: "cpsv",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.negative,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "CTR",
    value: "ctr",
    formatter: formatters.percentFormat,
    configFormatter: configNumberFormatter.percentFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "Engagements",
    value: "engagements",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Event Response",
    value: "event_response",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Impressions",
    value: "impressions",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard", order: 20 },
    calculationType: TYPE_SUM,
  },
  {
    title: "Intent Actions",
    value: "intent_actions",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Landing Page Visits",
    value: "landing_page_views",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Leads",
    value: "leads",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Link Clicks",
    value: "link_clicks",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Local Action",
    value: "local_action",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Page Likes",
    value: "page_likes",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Purchase Value",
    value: "purchase_value",
    formatter: formatters.currencyFormat,
    configFormatter: configNumberFormatter.integerCurrencyFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Purchases",
    value: "purchases",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "ROAS",
    value: "roas",
    formatter: formatters.numberFixedFormat,
    configFormatter: configNumberFormatter.numberFixedFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "Site Action",
    value: "site_action",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Store Visits",
    value: "store_visits",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "Submissions/Entries",
    value: "submission_entries",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
  {
    title: "VCR",
    value: "vcr",
    formatter: formatters.percentFormat,
    configFormatter: configNumberFormatter.percentFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "calculated" },
    calculationType: TYPE_AVERAGE,
  },
  {
    title: "Video Views",
    value: "video_views",
    formatter: formatters.integerFormat,
    configFormatter: configNumberFormatter.integerFormat,
    showTrend: true,
    trendUpColor: trendColors.positive,
    table: { group: "standard" },
    calculationType: TYPE_SUM,
  },
];
